import { FolderSimple, DownloadSimple } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { fmtBytes } from "@/lib/format";
import { toast } from "sonner";

const downloadArchive = (name) => {
  toast.info(`Preparing archive for "${name}"…`);
  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/folders/${encodeURIComponent(name)}/archive.zip`, "_blank");
};

export const FoldersGrid = ({ folders, storage = {}, onOpen, onRename, onShare }) => {
  const { hasPerm } = useAuth();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="folders-grid">
      {folders.map((f) => (
        <button key={f.name} data-testid={`folder-${f.name}`} onClick={() => onOpen(f.name)}
          className="text-left bg-card border border-border rounded-xl px-5 py-4 hover:border-primary hover:shadow-sm transition-all flex items-center gap-3 group">
          <div className="h-10 w-10 rounded-lg bg-primary/10 grid place-items-center shrink-0">
            <FolderSimple size={20} className="text-primary" weight="fill" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-semibold truncate group-hover:text-primary transition-colors">{f.name}</div>
            <div className="text-xs text-muted-foreground">
              {f.items.length} project{f.items.length === 1 ? "" : "s"}
              {storage[f.name] > 0 && (
                <span data-testid={`folder-size-${f.name}`}> · {fmtBytes(storage[f.name])}</span>
              )}
            </div>
          </div>
          <span className="flex items-center gap-0.5" onClick={(e) => e.stopPropagation()}>
            {hasPerm("edit_project") && (
              <span role="button" tabIndex={0} data-testid={`folder-rename-${f.name}`} title="Rename folder"
                onClick={() => onRename(f.name)}
                className="p-1.5 rounded-md text-muted-foreground opacity-0 group-hover:opacity-100 hover:bg-primary/10 hover:text-primary transition-all cursor-pointer">✎</span>
            )}
            {hasPerm("export_gis") && (
              <span role="button" tabIndex={0} data-testid={`folder-archive-${f.name}`} title="Download folder archive (all reports & data as ZIP)"
                onClick={() => downloadArchive(f.name)}
                className="p-1.5 rounded-md text-muted-foreground opacity-0 group-hover:opacity-100 hover:bg-primary/10 hover:text-primary transition-all cursor-pointer">
                <DownloadSimple size={15} />
              </span>
            )}
            {hasPerm("generate_reports") && (
              <span role="button" tabIndex={0} data-testid={`folder-share-${f.name}`} title="Share folder as client portfolio"
                onClick={() => onShare(f.name)}
                className="p-1.5 rounded-md text-muted-foreground opacity-0 group-hover:opacity-100 hover:bg-primary/10 hover:text-primary transition-all cursor-pointer">↗</span>
            )}
          </span>
        </button>
      ))}
    </div>
  );
};
